import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class NotificationPreferenceApi extends BaseApi {
    constructor(client) {
        super(client, '/notification-preference');
    }

    async getMyPreferences() {
        try {
            const response = await this.client.get(`${this.basePath}/my`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async updateMyPreferences(data) {
        try {
            const response = await this.client.put(`${this.basePath}/my`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
